import { render, staticRenderFns } from "./ConsentFormVerifiedView.vue?vue&type=template&id=0af51a94&scoped=true&"
import script from "./ConsentFormVerifiedView.vue?vue&type=script&lang=ts&"
export * from "./ConsentFormVerifiedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af51a94",
  null
  
)

export default component.exports